

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withTranslation } from "react-i18next";
import { Button, Form } from 'react-bootstrap';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import cryptoJs from 'crypto-js';
import RecoverPassword from './recoverPassword'
import SignalRService from '../../controllers/SignalRService';
import Toastr from '../utils/toastr';
import TwoFactorAuth from './twoFactorAuth';
import { setChangePassword } from '../../redux/parametersSlice';
import { useNavigate } from "react-router-dom";
import ChatsService from 'src/controllers/ChatController';
class Login extends Component {

    constructor(props) {

        super(props)

        this.state = {
            tenantName: window.location.host.split(".")[0],
            userName: "",
            userNameIsEmpty: false,
            password: "",
            passwordIsEmpty: false,
            shortExtension: "",
            logged: false,
            loading: false,
            showRecoverPwd: false,
            showCodeReq: false,
            token: ""
        };

        this.setUsername = this.setUsername.bind(this);
        this.setPassword = this.setPassword.bind(this);
        this.setExtension = this.setExtension.bind(this);
        this.keyDown = this.keyDown.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.setLogged = this.setLogged.bind(this);
        this.setLoading = this.setLoading.bind(this);
        this.associateResult = this.associateResult.bind(this);
        this.passwordExpiredEvent = this.passwordExpiredEvent.bind(this);
        this.toggleTwoFactorAuth = this.toggleTwoFactorAuth.bind(this);
        this.toggleRecoverPwd = this.toggleRecoverPwd.bind(this);
        SignalRService.registerAssociateResultEvent(this.associateResult);
        this.setToken = this.setToken.bind(this);
        this.resend = this.resend.bind(this);
        this.toastrRef = React.createRef();

    }
    
    componentDidMount() {
        localStorage.removeItem("fc-logged");
        ChatsService.disconnect();
    }

    passwordExpiredEvent = e => {
        this.setState({ showChangePassword: true });
    }

    setUsername(e) {
        e.preventDefault();
        this.setState({
            userName: e.target.value,
            userNameIsEmpty: e.target.value === null || (e.target.value !== null && e.target.value.trim() === "")
        });
    }

    setPassword(e) {
        e.preventDefault();
        this.setState({
            password: e.target.value,
            passwordIsEmpty: e.target.value === null || (e.target.value !== null && e.target.value.trim() === "")
        });
    }

    setExtension(e) {
        e.preventDefault();
        this.setState({
            shortExtension: e.target.value
        });
    }

    keyDown(e) {
        if (e.keyCode === 13) {
            this.handleSubmit(e);
        }
    }

    handleSubmit(e) {

        e.preventDefault();
        let userNameIsEmpty = this.state.userName === null || (this.state.userName !== null && this.state.userName.trim() === ""),
            passwordIsEmpty = this.state.password === null || (this.state.password !== null && this.state.password.trim() === ""),
            hostName = window.location.hostname;

        if (!userNameIsEmpty && !passwordIsEmpty) {

            this.setLoading(true);
            //! TODO: Trampa
            if (hostName === 'localhost' || hostName === '127.0.0.1')
                hostName = "devomni.fidelitycloud.es";

            let data = {
                tenantName: hostName.split(".")[0], // How it should be
                userName: this.state.userName,
                password: cryptoJs.SHA512(this.state.password).toString(),//this.props.hash ? cryptoJs.SHA512(this.state.password).toString() : this.state.password,
                shortExtension: this.state.shortExtension,
                userId: -1
            },
                dataStr = "";

            dataStr = JSON.stringify(data);

            localStorage.setItem("fc-logged", dataStr);

            SignalRService.associateMessage(data, (error) => {
                this.toastrRef.current.setType("error");
                this.toastrRef.current.setMessage(this.props.t("connectionerror"));
                this.toastrRef.current.show();
                this.setLoading(false);
            });

        } else {

            this.setState({
                userNameIsEmpty: userNameIsEmpty,
                passwordIsEmpty: passwordIsEmpty
            });

        }

    }

    setLogged(value) {
        this.setState({
            logged: value
        });
    }


    setLoading(value) {
        this.setState({
            loading: value
        })
    }

    associateResult(message) {

        this.setLoading(false);
        console.log(message);
        if (!message.userId) {
            this.toastrRef.current.setType("error");

            if (message.apiMessage) {
                this.toastrRef.current.setMessage(message.apiMessage);
                this.toastrRef.current.show();
            } else {
                if (message.message === "ENVIRONMENT_DISTINCT") {

                    this.toastrRef.current.setMessage(this.props.t("environmentdistinct"));
                    this.toastrRef.current.show();
                }
                if (message.message === "USER_LOCKED") {

                    this.toastrRef.current.setMessage(this.props.t("userlocked"));
                    this.toastrRef.current.show();
                }

                if (message.message === "CODE_REQUIRED") {
                    this.toggleTwoFactorAuth();
                }

                if (message.message === "ERROR") {
                    if (!this.state.showCodeReq) {
                        this.toastrRef.current.setMessage(this.props.t("wronguserorpasswordorextension"));
                        this.toastrRef.current.show();
                    } else {
                        this.toastrRef.current.setMessage(this.props.t("wrongcode"));
                        this.toastrRef.current.show();
                    }
                }
            }
        } else {
            if (message.userId === 0) {
                this.toastrRef.current.setType("error");
                this.toastrRef.current.setMessage(this.props.t("wronguserorpasswordorextension"));
                this.toastrRef.current.show();
            }

            if (message.userId === -1) {
                this.toastrRef.current.setType("error");
                this.toastrRef.current.setMessage(this.props.t("usernotagent"));
                this.toastrRef.current.show();
            }

            if (message.userId === -2) {
                this.toastrRef.current.setType("error");
                this.toastrRef.current.setMessage(this.props.t("userdisabled"));
                this.toastrRef.current.show();
            }

            if (message.userId === -3) {
                this.toastrRef.current.setType("error");
                this.toastrRef.current.setMessage(this.props.t("noavailablextensions"));
                this.toastrRef.current.show();
            }

            if (message.userId === -4) {
                this.toastrRef.current.setType("error");
                this.toastrRef.current.setMessage(this.props.t("unabletobind"));
                this.toastrRef.current.show();
            }

            if (message === null || message.message === "ERROR") {

                this.toastrRef.current.setType("error");
                this.toastrRef.current.setMessage(this.props.t("wronguserorpasswordorextension"));
                this.toastrRef.current.show();
            }


            if (message.userId > 0) {
                let loggedIn = localStorage.getItem("fc-logged");
                let data = JSON.parse(loggedIn);
                data.userId = message.userId;

                SignalRService.getMailCredentials({ userId: data.userId, extension: data.shortExtension }, (error) => { });

                data = JSON.stringify(data);
                console.log("Successfully logged!");
                localStorage.setItem("fc-logged", data);
                localStorage.setItem("faUserId", message.userId)
                localStorage.getItem("faExtension")
                localStorage.setItem("faChangePwd", message.message === "NEW_PASSWORD_REQUIRED")
                this.props.setChangePassword(message.message === "NEW_PASSWORD_REQUIRED");

                this.props.navigate("/main/interactions");
            }
        }

    }

    toggleRecoverPwd = e => {
        //e.preventDefault();
        this.setState({ showRecoverPwd: !this.state.showRecoverPwd });
    }

    toggleTwoFactorAuth = e => {
        //e.preventDefault();
        this.setState({ showCodeReq: !this.state.showCodeReq });
    }

    setToken = (token) => {
        let hostName = window.location.hostname;

        //! TODO: Trampa
        if (hostName === 'localhost' || hostName === '127.0.0.1')
            hostName = "devomni.fidelitycloud.es";

        let data = {
            tenantName: hostName.split(".")[0], // How it should be
            userName: this.state.userName,
            password: this.props.hash ? cryptoJs.SHA512(this.state.password).toString() : this.state.password,
            shortExtension: this.state.shortExtension,
            userId: -1,
            token: token
        }, dataStr = "";

        dataStr = JSON.stringify(data);
        localStorage.setItem("fc-logged", dataStr)
        SignalRService.twoFactorAssociate(data, (error) => {
            this.toastrRef.current.setType("error");
            this.toastrRef.current.setMessage(this.props.t("connectionerror"));
            this.toastrRef.current.show();
            this.setLoading(false);
        });
    }

    resend = () => {
        let data = {
            tenantName: window.location.host.split(".")[0], // How it should be
            userName: this.state.userName,
            password: this.props.hash ? cryptoJs.SHA512(this.state.password).toString() : this.state.password,
            shortExtension: this.state.shortExtension,
            userId: -1,
        }, dataStr = "";

        dataStr = JSON.stringify(data);
        localStorage.setItem("fc-logged", dataStr)
        SignalRService.resend(data, (error) => {
            this.toastrRef.current.setType("error");
            this.toastrRef.current.setMessage(this.props.t("connectionerror"));
            this.toastrRef.current.show();
            this.setLoading(false);
        });
    }

    render() {
        return (
            <>
                <BlockUi tag="div" blocking={this.state.loading} color="#009ef7" message={this.props.t("pleasewait")} style={{ height: "100%" }}>
                    <div className="app-blank" style={{ height: "100%" }}>
                        <div className="d-flex flex-column flex-root" style={{ height: "100%" }}>
                            <div className="d-flex flex-column flex-lg-row flex-column-fluid">
                                <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1">
                                    <div className="d-flex flex-center flex-column flex-lg-row-fluid">
                                        <div className="w-lg-500px p-10">
                                            <Form>
                                                <div className="text-center mb-11">
                                                    <h1 className="text-primary mb-3">{this.props.t("welcometitle")}</h1>
                                                    <div className="text-gray-500 fs-6">{this.props.t("omnichannel")}</div>
                                                </div>
                                                <div className="fv-row mb-8" data-kt-password-meter="true">

                                                    <Form.Group className="mb-4" controlId="fcUserName">
                                                        <Form.Control type="text" value={this.state.userName} onChange={this.setUsername} onKeyDown={this.keyDown} placeholder={this.props.t("username")} isInvalid={this.state.userNameIsEmpty} />
                                                        {
                                                            (this.state.userNameIsEmpty) &&
                                                            <Form.Text id="passwordHelpBlock" className='text-danger'>
                                                                {this.props.t("usernammeisempty")}
                                                            </Form.Text>
                                                        }
                                                    </Form.Group>

                                                    <Form.Group className="mb-4" controlId="fcPassword">
                                                        <Form.Control type="password" value={this.state.password} onChange={this.setPassword} onKeyDown={this.keyDown} placeholder={this.props.t("password")} isInvalid={this.state.passwordIsEmpty} />
                                                        {
                                                            (this.state.passwordIsEmpty) &&
                                                            <Form.Text id="passwordHelpBlock" className='text-danger'>
                                                                {this.props.t("passwordisempty")}
                                                            </Form.Text>
                                                        }
                                                    </Form.Group>

                                                    <Form.Group className="mb-4" controlId="fcExtension">
                                                        <Form.Control type="text" value={this.state.shortExtension} onChange={this.setExtension} onKeyDown={this.keyDown} placeholder={this.props.t("extension")} />
                                                        <Form.Text className="text-muted">
                                                        </Form.Text>
                                                    </Form.Group>

                                                </div>
                                                <div className="d-grid mb-10">
                                                    <Button variant="primary" onClick={this.handleSubmit} className="btn btn-primary">
                                                        {this.props.t("bind")}
                                                    </Button>
                                                </div>
                                                {
                                                    this.props.recover &&
                                                    <div className="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
                                                        <a href="/#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                this.toggleRecoverPwd();
                                                            }}
                                                            className="link-primary">
                                                            {this.props.t("recoverpwd")}
                                                        </a>
                                                    </div>
                                                }
                                            </Form>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2" style={{ backgroundImage: "url(img/background.jpg)" }}>
                                    <div className="d-flex flex-column flex-center py-7 py-lg-15 px-5 px-md-15 w-100">
                                        <div className="mb-0">
                                            <img alt="Logo" src="img/loginlogo.png" className="h-10px h-lg-150px" />
                                        </div>
                                        <img className="d-none d-lg-block mx-auto w-275px w-md-50 w-xl-500px mb-10 mb-lg-20" src="img/login.png" alt="" />
                                        <h1 className="d-none d-lg-block text-white text-center mb-7">{this.props.t("welcomeheader")}</h1>
                                        <div className="d-none d-lg-block text-white fs-base text-center">
                                            {this.props.t("welcomedescfirst")}
                                            <br />
                                            {this.props.t("welcomedescsecond")}
                                            <br />
                                            {this.props.t("welcomedescthird")}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                    <Toastr ref={this.toastrRef} />
                </BlockUi>
                <RecoverPassword show={this.state.showRecoverPwd} toggleModal={this.toggleRecoverPwd}></RecoverPassword>
                <TwoFactorAuth show={this.state.showCodeReq} toggleModal={this.toggleTwoFactorAuth} setToken={this.setToken} resend={this.resend}></TwoFactorAuth>
            </>
        );
    };
}

function WithNavigate(props) {
    let navigate = useNavigate();
    return <Login {...props} navigate={navigate} />
}

const mapStateToProps = (state) => {
    return {
        hash: state.parameters.passwordHashed,
        recover: state.parameters.passwordRecovery
    };
};
export default compose(connect(mapStateToProps, { setChangePassword }), withTranslation())(WithNavigate);
